const RATING_VALUES = [1, 2, 3, 4, 5];

export function diff(a: Record<string, any>, b: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(b).filter(([key, val]) => key in a && a[key] !== val),
  );
}

export function isObject(value: unknown): value is Object {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}

export function isString(value: unknown): boolean {
  return typeof value === 'string';
}

export function isNumber(value: unknown): boolean {
  return typeof value === 'number' && !Number.isNaN(value);
}

export function isRating(value: unknown): boolean {
  return typeof value === 'number' && RATING_VALUES.includes(value);
}
